import type { TeamFormValues } from '../../pages/Profile/CreateTeam/ZodValidationSchema'

const trimStr = (s: string) => s.trim()

const parseLines = (s: string) =>
  s
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)

const linesEqual = (a: string, b: string) => {
  const aa = parseLines(a)
  const bb = parseLines(b)
  if (aa.length !== bb.length) return false
  return aa.every((v, i) => v === bb[i])
}

const numberArraysEqual = (a: number[], b: number[]) => {
  if (a.length !== b.length) return false
  return a.every((v, i) => v === b[i])
}

const imageComparable = (v: TeamFormValues['image']): string | 'file' => {
  if (v instanceof File) return 'file'
  return trimStr(String(v ?? ''))
}

const imagesEqual = (a: TeamFormValues['image'], b: TeamFormValues['image']) => {
  const ca = imageComparable(a)
  const cb = imageComparable(b)
  if (ca === 'file' || cb === 'file') {
    return ca === 'file' && cb === 'file' && a instanceof File && b instanceof File && a === b
  }
  return ca === cb
}

export function areTeamFormOutputsEqual(a: TeamFormValues, b: TeamFormValues): boolean {
  if (trimStr(a.title) !== trimStr(b.title)) return false
  if (trimStr(a.city) !== trimStr(b.city)) return false
  if (trimStr(a.status) !== trimStr(b.status)) return false
  if (trimStr(a.descriptionShort) !== trimStr(b.descriptionShort)) return false
  if (trimStr(a.region) !== trimStr(b.region)) return false
  if (!imagesEqual(a.image, b.image)) return false
  if (!numberArraysEqual(a.directionIds, b.directionIds)) return false
  if (!linesEqual(a.goalsText, b.goalsText)) return false
  if (!linesEqual(a.resourcesText, b.resourcesText)) return false
  if (!linesEqual(a.needsText, b.needsText)) return false
  return true
}

export const isTeamFormUnchanged = (
  current: TeamFormValues,
  baseline: TeamFormValues,
): boolean => areTeamFormOutputsEqual(current, baseline)
